import { useMutation } from '@tanstack/react-query';
import { SignUpFormValues } from 'ui-components';
import { apiInstance } from 'utils';

export const useSignUp = () => {
	return useMutation({
		mutationKey: ['signUp'],
		mutationFn: async (values: SignUpFormValues) => {
			const [firstName, lastName] = values.name.split(' ');

			const data = await apiInstance.get<{
				portal_url: string | null;
				status: string;
				users: Array<Record<string, any>>;
			}>(
				`/account/search?term=${encodeURIComponent(values.companyName)}&qc=name`
			);
			if (!data.portal_url) throw new Error('Failed to get valid company slug');

			const postForm = new FormData();
			postForm.append('user[first_name]', firstName!);
			postForm.append('user[last_name]', lastName!);
			postForm.append('user[user_name]', values.companyName);
			postForm.append('user[portal_url]', values.portalUrl);
			postForm.append('user[phone]', '855123456789');
			postForm.append('user[email]', values.email);
			postForm.append('user[password]', values.password);
			return apiInstance.post('/clients/create_account.json', postForm);
		},
	});
};
